import Vue from 'vue';
import App from './App.vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import HighchartsVue from "highcharts-vue";
import VueZoomer from 'vue-zoomer';
import './assets/scss/custom-scss.scss';

import router from "./router";
import store from "./store";
import i18n from "./i18n";

import LoadScript from 'vue-plugin-load-script';

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(LoadScript);

// Install VueGoogleMaps
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDfNgFLvK3EUpQVMKm1-A-C8Rwh__Xiijc'
    }
});

// install HighchartsVue
Vue.use(HighchartsVue);

Vue.use(VueZoomer);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
